import React from "react"
import { Dialog, Icon } from "@tencent/spaui"
import _ from "lodash"

const MessageBox = React.createContext({
  strongwarn: (title, message) => alert(title + "\n" + message),
  warn: (title, message) => alert(title + "\n" + message),
  loading: (title, message) => alert(title + "\n" + message),
  success: (title, message) => alert(title + "\n" + message),
  error: (title, message) => alert(title + "\n" + message),
  info: (title, message) => alert(title + "\n" + message),
  confirm: (title, message, onSubmit, onCancel) => alert(title + "\n" + message),
})
export default MessageBox

export class MessageBoxContainer extends React.Component {
  state = {}

  render() {
    const { iconType, title, message, type, showButton } = this.state
    if (!iconType) {
      return null
    }

    if (_.isEmpty(title)) {
      return (
        <Dialog type={type} onSubmit={this.handleSubmit} onClose={this.handleCancel} onCancel={this.handleCancel} closeButton={true} submitButton={showButton} cancelButton={showButton} time={"error" === iconType ? 0 : 2000} timeCallback={this.closeMessageBox} style={{ width: "450px" }}>
          <h4>
            {" "}
            {"error" === iconType && "tip" !== type ? <Icon type="error" style={{ marginRight: 10 }} /> : null}
            {message}
          </h4>
        </Dialog>
      )
    }

    return (
      <Dialog type={type} onSubmit={this.handleSubmit} onClose={this.handleCancel} onCancel={this.handleCancel} closeButton={true} submitButton={showButton} cancelButton={showButton} time={"error" === iconType ? 0 : 2000} timeCallback={this.closeMessageBox} style={{ width: "450px" }}>
        <h4>
          {" "}
          {"error" === iconType && "tip" !== type ? <Icon type="error" style={{ marginRight: 10 }} /> : null}
          {title}
        </h4>
        <div>{message}</div>
      </Dialog>
    )
  }

  strongwarn = (title, message) => {
    this.setState({
      type: "normal",
      iconType: "strongwarn",
      title,
      message,
      showButton: false,
    })
  }

  warn = (title, message) => {
    this.setState({
      type: "normal",
      iconType: "warn",
      title,
      message,
      showButton: false,
    })
  }

  loading = (title, message) => {
    this.setState({
      type: "tip",
      iconType: "loading",
      title,
      message,
      showButton: false,
    })
  }

  success = (title, message) => {
    this.setState({
      type: "tip",
      iconType: "success",
      title,
      message,
      showButton: false,
    })
  }

  error = (title, message) => {
    this.setState({
      type: "normal",
      iconType: "error",
      title,
      message,
      showButton: false,
    })
  }

  info = (title, message) => {
    this.setState({
      type: "tip",
      iconType: "info",
      title,
      message,
      showButton: false,
    })
  }

  confirm = (title, message, onSubmit, onCancel) => {
    this.setState({
      type: "confirm",
      iconType: "confirm",
      title,
      message,
      onSubmit,
      onCancel,
      showButton: true,
    })
  }

  handleSubmit = (e) => {
    let { onSubmit } = this.state
    this.closeMessageBox()
    if (onSubmit) {
      onSubmit(e)
    }
  }

  handleCancel = (e) => {
    let { onCancel } = this.state
    this.closeMessageBox()
    if (onCancel) {
      onCancel(e)
    }
  }

  closeMessageBox = () => {
    this.setState({
      type: undefined,
      iconType: undefined,
      title: undefined,
      message: undefined,
      onCancel: undefined,
      onSubmit: undefined,
      showButton: undefined,
    })
  }
}
